import {
  CostConfigurationUpload,
  useDownloadChangesFile,
  useDownloadErrorsFile,
} from 'components/profitability/configQueryHooks';
import { useIntl } from 'react-intl';
import { TbIcon } from 'components/Figma';
import { useDownloadProgress } from 'hooks/useDownloadProgress';
import { IconButton } from '@mui/material';

export interface DetailsColumnWidgetProps {
  uploadDetails: CostConfigurationUpload;
}

export function DetailsColumnWidget({ uploadDetails }: DetailsColumnWidgetProps) {
  const intl = useIntl();
  const { withDownloadProgress } = useDownloadProgress();

  const isErrorDetails = uploadDetails.errorCount > 0;

  const isDownload = uploadDetails.errorCount > 0 || uploadDetails.changeCount > 0;

  const downloadChanges = useDownloadChangesFile(uploadDetails.uploadId);
  const downloadErrors = useDownloadErrorsFile(uploadDetails.uploadId);

  const text = intl.formatMessage(
    {
      id: isErrorDetails
        ? 'profitability.cost-configurations.details.errors'
        : 'profitability.cost-configurations.details.changes',
    },
    { errorCount: uploadDetails.errorCount, changeCount: uploadDetails.changeCount }
  );

  const downloadDetails = () => {
    const fnDownload = isErrorDetails ? downloadErrors : downloadChanges;

    withDownloadProgress(() => fnDownload());
  };

  return (
    <div className="flex w-full items-center">
      <div className="flex-grow text-left">{text}</div>
      <div className="w-8 flex-shrink-0 text-right">
        {isDownload && (
          <IconButton
            aria-label="download"
            data-testid={`change-download`}
            onClick={downloadDetails}
            sx={{ borderRadius: 0, padding: 0 }}
          >
            <TbIcon name="Download" size="xl" />
          </IconButton>
        )}
      </div>
    </div>
  );
}
